/* angular */
import { createAction, props } from '@ngrx/store';
import {
  GetTokenByCredentialsActionPayload,
  GetTokenByCredentialsSuccessfulActionPayload,
  LoggedInActionPayload,
  RegisterActionPayload,
  RegisterSuccessfulActionPayload,
  SetUserActionPayload,
  LoginByTokenActionPayload,
  SetTokenActionPayload,
} from 'src/app/features/shared/models/event/auth-data-store';
import { GetOtpByPhoneNumberPayload, GetTokenByOtpPayload, GetTokenByOtpSuccessfulPayload } from 'src/app/features/shared/models/event/auth-data-store/otp-by-phone-number.interface';

/* action types */
export enum ActionTypes {
  GetTokenByCredentials = '[AUTHDATASTORE] GetTokenByCredentials',
  GetTokenByCredentialsSuccessful = '[AUTHDATASTORE] GetTokenByCredentialsSuccessful',
  GetTokenByCredentialsFailure = '[AUTHDATASTORE] GetTokenByCredentialsFailure',
  GetOtpByPhoneNumber = '[AUTHDATASTORE] GetOtpByPhoneNumber',
  GetOtpByPhoneNumberSuccessful = '[AUTHDATASTORE] GetOtpByPhoneNumberSuccessful',
  GetOtpByPhoneNumberFailure = '[AUTHDATASTORE] GetOtpByPhoneNumberFailure',
  GetTokenByOtp = '[AUTHDATASTORE] GetTokenByOtp',
  GetTokenByOtpSuccessful = '[AUTHDATASTORE] GetTokenByOtpSuccessful',
  GetTokenByOtpFailure = '[AUTHDATASTORE] GetTokenByOtpFailure',
  Logout = '[AUTHDATASTORE] Logout',
  LoginByToken = '[AUTHDATASTORE] LoginByToken',
  LoggedIn = '[AUTHDATASTORE] LoggedIn',
  LoginByTokenFailure = '[AUTHDATASTORE] LoginByTokenFailure',
  Register = '[AUTHDATASTORE] Register',
  RegisterSuccessful = '[AUTHDATASTORE] RegisterSuccessful',
  RegisterFailure = '[AUTHDATASTORE] RegisterFailure',
  SetUser = '[AUTHDATASTORE] SetUser',
  SetToken = '[AUTHDATASTORE] SetToken',
  ClearToken = '[AUTHDATASTORE] ClearToken',
  NavigateToLoginPage = '[AUTHDATASTORE] NavigateToLoginPage',
  NavigateToRegisterPage = '[AUTHDATASTORE] NavigateToRegisterPage',
}

/* actions */

export const GetTokenByCredentials = createAction(
  ActionTypes.GetTokenByCredentials,
  props<{ payload: GetTokenByCredentialsActionPayload }>(),
);

export const GetTokenByCredentialsSuccessful = createAction(
  ActionTypes.GetTokenByCredentialsSuccessful,
  props<{ payload: GetTokenByCredentialsSuccessfulActionPayload }>(),
);

export const GetOtpByPhoneNumber = createAction(
  ActionTypes.GetOtpByPhoneNumber,
  props<{ payload: GetOtpByPhoneNumberPayload }>(),
);

export const GetOtpByPhoneNumberSuccessful = createAction(
  ActionTypes.GetOtpByPhoneNumberSuccessful,
  props<{ payload: GetTokenByCredentialsActionPayload }>(),
);

export const GetOtpByPhoneNumberFailure = createAction(
  ActionTypes.GetOtpByPhoneNumberFailure,
);

export const GetTokenByOtp = createAction(
  ActionTypes.GetTokenByOtp,
  props<{ payload: GetTokenByOtpPayload }>(),
);

export const GetTokenByOtpSuccessful = createAction(
  ActionTypes.GetTokenByOtpSuccessful,
  props<{ payload: GetTokenByOtpSuccessfulPayload }>(),
);

export const GetTokenByCredentialsFailure = createAction(
  ActionTypes.GetTokenByCredentialsFailure,
);

export const Logout = createAction(ActionTypes.Logout);

export const LoginByToken = createAction(
  ActionTypes.LoginByToken,
  props<{ payload: LoginByTokenActionPayload }>(),
);

export const LoggedIn = createAction(
  ActionTypes.LoggedIn,
  props<{ payload: LoggedInActionPayload }>(),
);

export const LoginByTokenFailure = createAction(
  ActionTypes.LoginByTokenFailure,
);

export const Register = createAction(
  ActionTypes.Register,
  props<{ payload: RegisterActionPayload }>(),
);

export const RegisterSuccessful = createAction(
  ActionTypes.RegisterSuccessful,
  props<{ payload: RegisterSuccessfulActionPayload }>(),
);

export const RegisterFailure = createAction(ActionTypes.RegisterFailure);

export const SetUser = createAction(
  ActionTypes.SetUser,
  props<{ payload: SetUserActionPayload }>(),
);

export const SetToken = createAction(
  ActionTypes.SetToken,
  props<{ payload: SetTokenActionPayload }>(),
);

export const ClearToken = createAction(ActionTypes.ClearToken);

export const NavigateToLoginPage = createAction(
  ActionTypes.NavigateToLoginPage,
);

export const NavigateToRegisterPage = createAction(
  ActionTypes.NavigateToRegisterPage,
);
